import { z } from "zod";
export const MaintenancePhaseSchema = z.enum([
    "normal",
    "pausing",
    "paused",
    "preparing",
    "resuming",
]);
export const MaintenanceStatusSchema = z.object({
    available: z.boolean(),
    phase: z.enum([
        "normal",
        "pausing",
        "paused",
        "preparing",
        "resuming",
        "unavailable",
    ]),
    operation: z.string().nullable(),
    message: z.string(),
    controlVersion: z.string().regex(/^[0-9a-f]{20}$/i).nullish(),
    requiresAdminAction: z.boolean().optional().describe("When true, service recovery requires administrator action. Omitted by older servers; no private diagnostic details are exposed."),
}).refine((s) => !s.available || s.phase === "normal", {
    message: "Only a normal service can be available",
}).refine((s) => !isMaintenancePhase(s.phase) || (!s.available && !!s.operation), {
    message: "Maintenance requires an operation and an unavailable service",
});
export function isMaintenancePhase(phase) {
    return ["pausing", "paused", "preparing", "resuming"].includes(phase);
}
